import { IDataGridColumnConfiguration } from '@trackman/baseball-shared-components';
import { IDataGridValidator } from '@trackman/baseball-shared-components/build/models/DataGrid/IDataGridValidator';
import { IDataGridError } from '@trackman/baseball-shared-components/build/models/DataGrid/IDataGridError';
import { PlayRow } from 'models/PlayEditRow/PlayRow';
import { EditRowColumnName } from 'enums/EditRowColumnName';
import { EditRowDataKey } from '../../enums/EditRowDataKey';

export const previousRowConsistencyValidator: IDataGridValidator = {
  validate: (rows: PlayRow[], columns: IDataGridColumnConfiguration[]) => {
    const result: IDataGridError[][] = [];
    let prevLivePlayIndex = -1;
    for (let i = 0; i < rows.length; i++) {
      const errors: IDataGridError[] = [];
      const row = rows[i];
      if (!row.isWarmup && !row.isDeleted) {
        if (prevLivePlayIndex !== -1) {
          const prevRow = rows[prevLivePlayIndex];
          validatePDex(row, prevRow, errors);
          validateBSide(row, prevRow, errors);
          validateInning(row, prevRow, errors);
        }
        prevLivePlayIndex = i;
      }
      result.push(errors);
    }
    return result;
  },
};

const validatePDex = (row: PlayRow, prevRow: PlayRow, errors: IDataGridError[]) => {
  if (row.pitcher.name === prevRow.pitcher.name && row.pitcherDexterity !== prevRow.pitcherDexterity) {
    errors.push({
      dataKey: EditRowDataKey.PitcherDexterity,
      errorMessage: `${EditRowColumnName.PitcherDexterity} changed between pitches`,
    });
  }
};

const validateBSide = (row: PlayRow, prevRow: PlayRow, errors: IDataGridError[]) => {
  if (row.batter.name === prevRow.batter.name && row.batterDexterity !== prevRow.batterDexterity) {
    errors.push({
      dataKey: EditRowDataKey.BatterDexterity,
      errorMessage: `${EditRowColumnName.BattingSide} changed between pitches`,
    });
  }
};

const validateInning = (row: PlayRow, prevRow: PlayRow, errors: IDataGridError[]) => {
  // if inning decreased
  if (
    row.inning.inningNumber < prevRow.inning.inningNumber ||
    (row.inning.inningNumber === prevRow.inning.inningNumber && row.inning.isTopInning && !prevRow.inning.isTopInning)
  ) {
    errors.push({
      dataKey: EditRowDataKey.Inning,
      errorMessage: `${EditRowColumnName.Inning} decreased`,
    });
  }
};
